import React from 'react';
import { Flex } from 'components/Grid';

import Paragraph from 'components/Paragraph';
import styled from 'styled-components';
import hand from '../../images/hand-down.png';
import theme, { mq } from 'utils/styles/theme';

const SectionNavigationStyled = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	padding: 30px;
	height: calc(100vh - ${theme.sizes.headerHeight});
	top: ${theme.sizes.headerHeight};
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: space-between;
	z-index: 1;
	display: none;

	${mq.large} {
		display: flex;
	}

	.navigation-hand {
		height: 40px;
		width: 40px;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		&:first-child {
			transform: rotate(180deg);
		}
	}

	.navigation-items {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		cursor: ${theme.cursor.pointer};

		.navigation-item {
			display: flex;
			margin-top: 20px;
			align-items: center;

			&:hover {
				p {
					opacity: 0.4;
				}
			}

			p {
				margin-bottom: 0;
				margin-right: 15px;
				opacity: 0;
				transition: opacity 0.3s ease-in-out;

				&.visible {
					opacity: 1;
				}
			}

			.bullet {
				border: 1px solid black;
				transform: rotate(45deg);
				width: 10px;
				height: 10px;

				&.active {
					background-color: black;
				}
			}
		}
	}
`;

const SectionNavigation = ({ bullets, handleNavClick, activeBulletIndex }) => (
	<SectionNavigationStyled>
		<div className="navigation-hand">
			{activeBulletIndex !== 0 && <img onClick={() => handleNavClick('up')} src={hand} />}
		</div>
		<div className="navigation-items">
			{bullets.map((item, key) => {
				return (
					<div key={key} className="navigation-item" onClick={() => handleNavClick('', key)}>
						<Paragraph
							className={`${activeBulletIndex === key && 'visible'} ${activeBulletIndex ===
								key - 1 && 'semi-visible'}`}
							fontFamily="headlines"
							fontSize="12px"
							mb={0}
						>
							{item.title}
						</Paragraph>
						<div className={`bullet ${activeBulletIndex === key && 'active'}`}></div>
					</div>
				);
			})}
		</div>
		<div className="navigation-hand">
			{activeBulletIndex !== 3 && <img onClick={() => handleNavClick('down')} src={hand} />}
		</div>
	</SectionNavigationStyled>
);

SectionNavigation.propTypes = {};

SectionNavigation.defaultProps = {};

export default SectionNavigation;
